import React from 'react';
import PropTypes from 'prop-types';

import Container from '@Theme/hijunior/components/Container/Container';
import ArticleTile from '@Theme/hijunior/components/ArticleTile/ArticleTile';

import * as styles from './GenericBlog.module.scss';

const propTypes = {
  /**
   * Heading content
   */
  heading: PropTypes.string,

  /**
   * Blog cards content - href, picture, category, heading, description, date, readTime
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      picture: PropTypes.shape({
        xs: PropTypes.exact({
          src: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number
        }).isRequired,
        alt: PropTypes.string
      }),
      heading: PropTypes.string,
      category: PropTypes.string,
      date: PropTypes.string
    })
  ),

  variant: PropTypes.oneOf([
    'White',
    'LightGray'
  ])
};

const GenericBlog = ({
  heading,
  variant,
  items
}) => {
  if (!heading && !items) {
    return false;
  }

  return <section className={`${styles.root} ${variant ? styles[`root${variant}`] : ''}`}>
    <Container>
      <div className={styles.rootHeading}>{heading}</div>
      <div className={styles.rootCards}>
        {items?.map((item, index) => <ArticleTile {...item} key={index}/>)}
      </div>
    </Container>
  </section>;
};

GenericBlog.propTypes = propTypes;

export default GenericBlog;
